(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7992],{

/***/ 38551:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var components_lobbypage_LobbyPage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78536);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






var Construction = function Construction(_ref) {
  var _data$ogImage, _data$ogImage$media;

  var data = _ref.data,
      assets = _ref.assets,
      searchMetadata = _ref.searchMetadata;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
      title: data === null || data === void 0 ? void 0 : data.metaTitle,
      description: data === null || data === void 0 ? void 0 : data.metaDescription,
      additionalMetaTags: [{
        name: "keywords",
        content: data.metaKeywords
      }],
      openGraph: {
        title: (data === null || data === void 0 ? void 0 : data.ogTitle) || (data === null || data === void 0 ? void 0 : data.metaTitle),
        description: (data === null || data === void 0 ? void 0 : data.ogDescription) || (data === null || data === void 0 ? void 0 : data.metaDescription),
        images: [{
          url: (data === null || data === void 0 ? void 0 : (_data$ogImage = data.ogImage) === null || _data$ogImage === void 0 ? void 0 : (_data$ogImage$media = _data$ogImage.media) === null || _data$ogImage$media === void 0 ? void 0 : _data$ogImage$media.publicUrl) || ""
        }]
      }
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_lobbypage_LobbyPage__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
      data: data,
      assets: assets,
      searchMetadata: searchMetadata,
      hideSearch: true,
      pageType: "construction"
    })]
  });
};

var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Construction);

/***/ }),

/***/ 95503:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/construction",
      function () {
        return __webpack_require__(38551);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,7611,719,5847,3722,4293,2745,8536,9774,2888,179], function() { return __webpack_exec__(95503); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);